import { render, staticRenderFns } from "./starrating.vue?vue&type=template&id=51a7f3e5&"
import script from "./starrating.vue?vue&type=script&lang=js&"
export * from "./starrating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51a7f3e5')) {
      api.createRecord('51a7f3e5', component.options)
    } else {
      api.reload('51a7f3e5', component.options)
    }
    module.hot.accept("./starrating.vue?vue&type=template&id=51a7f3e5&", function () {
      api.rerender('51a7f3e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ix918rsNzVKp/JS/comp/starrating.vue"
export default component.exports